/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { seguridad } from '../../conexiones';
import IBanco from './entidades/banco';

export default class ModeloBanco {
    public consultarBanco() {
        return manejadorRest<IRespuesta<IBanco>>(() => seguridad.get('Banco/ConsultarListaBanco'), true);
    }
    public crearBanco(banco: IBanco) {
        return manejadorRest<IRespuesta<IBanco>>(() => seguridad.post('Banco/GuardarBanco', banco));
    }
    public editarBanco(banco: IBanco) {
        return manejadorRest<IRespuesta<IBanco>>(() => seguridad.put('Banco/EditarBanco', banco));
    }
    public eliminarBanco(banco: IBanco) {
        return manejadorRest<IRespuesta<IBanco>>(() => seguridad.delete('Banco/EliminarBanco', banco));
    }
}
